export default __webpack_public_path__ + "empty-environment-md.efa33f3c.svg";